import axios from "../axios-auth";
import orginal_axios from "axios";

export const operationSettingService = {
    getOperationSettingList,
    saveOperationSetting,
    getOperationSettingDetail,
    getOperationSettingTypes,
    getOperationSettingListByDepreciation,
    getOperationSettingExcelExport,
    getAllOperationSettingList,
    getAllOperationSettings,
    getOperationSettingExcelTemplate,
    saveOperationSettingExcel,
    getOperationSettingListByType,
};

function getOperationSettingList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.operationType) {
        params["operationType"] = searchParams.operationType;
    }
    if (typeof (searchParams.auto) == 'boolean') {
        params["auto"] = searchParams.auto;
    }
    return axios.get("/auth/operation-settings", { params });
}

function saveOperationSetting(operationSetting) {
    if (!operationSetting.id) {
        // new operation setting
        return axios.post("/auth/operation-setting", operationSetting);
    } else {
        // edit
        return axios.put("/auth/operation-setting", operationSetting);
    }
}

function getOperationSettingDetail(id) {
    return axios.get("/auth/operation-setting/" + id);
}

function getOperationSettingTypes() {
    return axios.get("/auth/operation-setting-types/");
}

function getOperationSettingListByDepreciation() {
    return axios.get("auth/operation-setting/depreciation");
}

function getOperationSettingExcelExport(searchParams) {
    let params = {};
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.operationType) {
        params["operationType"] = searchParams.operationType;
    }
    if (typeof (searchParams.auto) == 'boolean') {
        params["auto"] = searchParams.auto;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/operation-setting-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllOperationSettingList(searchParams) {
    let params = {};

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.operationType) {
        params["operationType"] = searchParams.operationType;
    }
    if (typeof (searchParams.auto) == 'boolean') {
        params["auto"] = searchParams.auto;
    }

    return axios.get("/auth/print-all-operation-setting");
}

function getAllOperationSettings() {
    return axios.get("/auth/all-operation-settings");
}

function getOperationSettingListByType(type) {
  return axios.get("/auth/all-operation-settings-by-type/" + type);
}

function getOperationSettingExcelTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/operation-setting-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function saveOperationSettingExcel(file) {
    return axios.post('/auth/operation-setting-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}
